import React from 'react';

import BaseNavigator from './BaseNavigator';

const MemberNavigator = () => {
  return <BaseNavigator signedIn={false} isPro={false} />;
};

export default React.memo(MemberNavigator);
